/**
 * getKey
 * Generate a unique key to use in React loops
 * Use the simplest way possible
 *
 * @return int
 */

let key = 0
export const getKey = () => key++

/**
 * validateFields
 * Validate input fields values
 * with their corresponding regex
 *
 * @return bool
 */
export const validateFields = (field, fieldValue) => {
  return field.pattern.test(fieldValue)
}
